import { TFunction } from "i18next";

export const handleCopyEntity = async ({
  copyFn,
  id,
  refetchFn,
  onBeforeCopy,
  onSuccess,
  onError,
  t,
}: {
  copyFn: (id: string | number) => Promise<any>;
  id: string | number;
  refetchFn?: () => void | Promise<unknown>;
  onBeforeCopy?: () => void;
  onSuccess?: (title: string, message: string, response: any) => void;
  onError?: (title: string, message: string) => void;
  t: TFunction;
}) => {
  let response: any;

  try {
    onBeforeCopy?.();

    response = await copyFn(id);

    return response;
  } catch (error: any) {
    const errorTitle = error?.data?.title ?? error?.title ?? "Unknown error";
    const errorStatus = error?.data?.status ?? error?.status ?? "N/A";
    const errorDetail = error?.data?.detail ?? error?.detail ?? "N/A";

    onError?.(`${errorTitle} (${errorStatus})`, errorDetail);

    throw error;
  } finally {
    await refetchFn?.();

    if (response) {
      const title =
        response?.title ?? t("MessageOperationCompletedSuceesuflly");

      const message = response?.message ?? "";

      onSuccess?.(title, message, response);
    }
  }
};